import { Link } from "react-router-dom";
import { Stack } from "../../../shared/ui/Stack/Stack";
import styles from './MyWorks.module.scss'
import {motion as m} from "framer-motion";
import { Text } from "../../../shared/ui/Text/Text";
import { myWorksData } from "../lib/data";


const MyWorks = () => {
    return ( 
        <section className = {styles.container}>
            <m.div
                initial = 'hidden'
                animate = 'visible'
                variants={{
                    hidden: {
                        opacity: 0,
                    },
                    visible: {
                        opacity: 1,
                        transition: {
                            duration: 2,
                        }
                    }
                }}
            >
            <Stack 
                justifyContent = 'justifyCenter'   
                className={styles.title__content}>
                    <m.div
                        variants = {{
                        hidden:{ opacity: 0, y:20},
                        visible: { opacity: 1, y: 0}
                    }}
                    transition = {{ duration: 0.6 }}>
                        <Text type="h3" size='l' className={styles.title}>
                            ВАША ИСТОРИЯ МОИМИ ГЛАЗАМИ...
                        </Text> 
                    </m.div>   
            </Stack>
            </m.div>
        <div className = {styles.container__photo}>          
            <Stack
                justifyContent = 'justifyCenter'
                alignItems='alignCenter'
                gap = '32'
                className = {styles.content}>

                {myWorksData.map(({index, src, text, btn}) => (
                    <m.div 
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 3, delay: index * 0.2 }}key={index}>
                    <Link to={btn}  className = {styles.row}>
                        <img  className={styles.photo} src={src} alt="свадебные, семейные, детские фотосессии Ставрополь" />
                        <Text size="m" className={styles.text}>{text}</Text>
                    </Link>   
                    </m.div>             
                ))}
            </Stack>
        </div>
        </section>
     );
}
export default MyWorks;